




<!-- <section class="section_one"> -->
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <!-- desktop table view open-->
                <div class="ibox">
                    <!-- <form [formGroup]="myGroup" > -->
                        <div>
                            <div class="ibox-title report_flexweb">
                                <div>
                                    <h5 class="addcamera">Search Employee</h5>
                                </div>
                                <div>
                                    <figure>
                                        <img src="../../assets/image/baseline-close.svg" [mat-dialog-close]="true"/>
                                    </figure>
                                </div>
                            </div>
                            <div class="input-group inputSearch">
                                <input class="form-control py-2 border-right-0 border" type="search"
                                    value="Search Employess" id="example-search-input" placeholder= "Search by PAYROLLId"
                                    [(ngModel)]="searchTerm">
                                <span class="input-group-append">
                                    <button class="btn btn-outline-secondary border-left-0 border"
                                        type="button" (click)="employessearch()">
                                        <i class="fa fa-search"></i>
                                    </button>
                                </span>
                            </div>
                            <div class="card">
                                   
                                <!-- <div class="card">
                                    <div>
                                        <p class="campus-name">Campus Name</p>
                                        <select class="form-select" aria-label="Default select example" (change)="onCampusChange($event)">
                                            <option selected class="campus-option">Select the Campus</option>
                                            <option *ngFor="let campus of campusData" [value]="campus.campusId" >
                                              {{ campus.campusName }}
                                            </option>
                                          </select>
                                    </div>
                                    <div>
                                        <p class="campus-name">Building Name</p>
                                        <select class="form-select" aria-label="Default select example" (change)="onbuilding($event)">
                                            <option selected class="campus-option">Select the Campus</option>
                                            <option *ngFor="let building of buildingData" [value]="building.buildingId" >
                                              {{ building.buildingName }}
                                            </option>
                                          </select>
                                    </div>
                                    <div class="cameras1" >
                                        <ng-container *ngFor="let camera of cctvcameralist?.cameraDetails">
                                        <figure  *ngIf="camera.alreadyAdded" class="cctv">
                                          <img [src]="camera.cctvFrameS3Url" class="cameras" >
                                          <p class="building-name">{{ camera.buildingName }}</p>
                                        </figure>
                                        </ng-container>
                                      </div>
                                </div> -->
                                <div class="card" *ngIf=" searchemployesslist"  (click)="cardopen(searchemployesslist)">
                                    <div class="p">
                                        <figure>
                                            <img [src]="imageUrl" class="photo" alt="Employee Photo">
                                        </figure>
                                    </div>
                                    <div class="text">
                                        <h1 class="text-name">{{ searchemployesslist.empName }}</h1>
                                        <hr>
                                        <p class="text-payroll">PAYROLL ID: {{ searchemployesslist.payrollId }}</p>
                                        <hr>
                                        <p class="text-designation">DESIGNATION: {{ searchemployesslist.designation }}</p>
                                        <hr>
                                        <p class="text-date">MOBILE NO: {{ searchemployesslist.mobileNo }}</p>
                                    </div>
                                    
                                </div>
                                <div>
                                    <div *ngIf="!searchemployesslist">
                                        <p>No employees found.</p>
                                    </div>
                            </div>
                           
                            
                        </div>
                    <!-- </form> -->
                    <!-- desktop table view close-->
                </div>
            </div>
        </div>
    </div>
<!-- </section>
</a> -->

